"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasAuthCookie = hasAuthCookie;
function hasAuthCookie() {
  return document && document.cookie && document.cookie.indexOf("5AJWT_AUTH") >= 0;
}